import livro from './livroRepository'
import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/farmacia`

    const headers = { responseType: "arraybuffer" }

    return {
        livro: livro(baseUrl),
        receita(id, queryParms = {}) {

            return repository.get(`${baseUrl}/receita/${id}?${urlUtil.serialize(queryParms)}`, headers)
        },
        receitaRemedioEmCasa(id) {

            return repository.get(`${baseUrl}/receita-remedio-em-casa/${id}`, headers)
        },
        relatorioDispensacaoPaciente(queryParms) {

            return repository.get(`${baseUrl}/relatorio-dispensacao-paciente?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioDispensacao(queryParms) {

            return repository.get(`${baseUrl}/relatorio-dispensacao?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioPacienteAtendido(queryParms) {

            return repository.get(`${baseUrl}/relatorio-paciente-atendido?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioMovimentacaoPsicotropico(queryParms) {

            return repository.get(`${baseUrl}/relatorio-movimentacao-psicotropico?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioQuantitativoDispensacao(queryParms) {

            return repository.get(`${baseUrl}/relatorio-quantitativo-dispensacao?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioEstornoDispensacao(queryParms) {

            return repository.get(`${baseUrl}/relatorio-estorno-dispensacao?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioAltoCustoRetiradaPendente(queryParms) {

            return repository.get(`${baseUrl}/relatorio-alto-custo-retirada-pendente?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioAltoCustoProcesso(queryParms) {

            return repository.get(`${baseUrl}/relatorio-alto-custo-processo?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioAtendimentoDiario(queryParms) {

            return repository.get(`${baseUrl}/relatorio-atendimento-diario?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioAltoCustoDispensacao(queryParms) {

            return repository.get(`${baseUrl}/relatorio-alto-custo-dispensacao?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioAltoCustoProcessoPaciente(queryParms) {

            return repository.get(`${baseUrl}/relatorio-alto-custo-processo-paciente?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioAltoCustoEstatisticoCid(queryParms) {

            return repository.get(`${baseUrl}/relatorio-alto-custo-estatistico-cid?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioDispensacaoRemedioCasa(queryParms) {

            return repository.get(`${baseUrl}/relatorio-dispensacao-remedio-casa?${urlUtil.serialize(queryParms)}`, headers)
        },
    }
}
